/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchUserAccountAssetResponseItem { 
    currencyId: number;
    currencyTicker: string;
    currencyName: string;
    chainId: number;
    chainName: string;
    amount: number;
    totalWorkers?: number | null;
    activeWorkers?: number | null;
    inactiveWorkers?: number | null;
    avgDailyHashrate?: number | null;
}

